"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M10.874.349a1.998 1.998 0 0 0-.734.921C7.18 2.13 5 5 5 8.41v5.1c-.195.209-.453.443-.733.698l-.051.046-.007.006C3.234 15.145 2 16.266 2 17.41c0 .88.67 1.59 1.5 1.59h17c.83 0 1.5-.71 1.5-1.59 0-1.146-1.239-2.27-2.216-3.156l-.009-.008c-.297-.27-.57-.517-.775-.736v-5.1c0-3.41-2.18-6.28-5.14-7.14a1.998 1.998 0 0 0-2.986-.921ZM4.29 17c.37-.44.97-.99 1.29-1.28l.037-.034.016-.015c.3-.271.581-.526.827-.791l.55-.58V8.4c0-2.98 2.24-5.41 5-5.41s5 2.43 5 5.41v5.9l.55.58c.26.27.56.55.88.84l.008.007c.312.282.915.827 1.282 1.273H4.29Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M9 21v.142A2.862 2.862 0 0 0 11.857 24H12a3 3 0 0 0 3-3H9Z"
  })]
});